// import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { Switch, Route, Router } from 'react-router-dom';
import {privateRoutesPath, publicRoutesPath} from './Routes/index';
import PrivateRoute from './Routes/PrivateRoute';
import PublicRoute from './Routes/PublicRoute';
import history from './Utility/history';
import './App.css';
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';

function App() {
  
  return (
<Router basename={process.env.REACT_APP_BASENAME || ""} history={history}>
      <Switch>
        <Route component={PrivateRoute} path={privateRoutesPath.BIZTANTU} />
        <Route component={PublicRoute} path={publicRoutesPath.LOGIN} />
      </Switch>
    </Router>
  );
}

export default App;
